<template>
  <div
    class="chart"
  >
    <BackBtn
      class="back-btn"
      @click.native="$router.back(-1)"
    />
    <van-picker
      ref="year-picker"
      class="picker"
      :columns="pickerYears"
      visible-item-count="3"
      :default-index="currentYearIndex"
      item-height="2.36rem"
      @change="onPickerChange"
    />
    <div
      v-show="yearDataDetail[currentYearIndex]['观众数']"
      class="guanzhongshu data-circle"
      :style="{
        transform: `translate(${bubbleTranslation[0].x}rem, ${bubbleTranslation[0].y}rem)`
      }"
    >
      <h3>
        观众数
      </h3>
      <div class="data-wrapper">
        <span class="number-big">{{ bubbleDataForShow['观众数'][0] }}</span>
        <span class="number-small">{{ bubbleDataForShow['观众数'][1] }}</span>
      </div>
      <img
        draggable="false"
        src="@/assets/image/观众数.png"
        alt=""
      >
    </div>
    <div
      v-show="yearDataDetail[currentYearIndex]['临展数']"
      class="linzhanshu data-circle"
      :style="{
        transform: `translate(${bubbleTranslation[1].x}rem, ${bubbleTranslation[1].y}rem)`
      }"
    >
      <h3>临展数</h3>
      <div class="data-wrapper">
        <span class="number-big">{{ bubbleDataForShow['临展数'][0] }}</span>
        <span class="number-small">{{ bubbleDataForShow['临展数'][1] }}</span>
      </div>
      <img
        draggable="false"
        src="@/assets/image/临展数.png"
        alt=""
      >
    </div>
    <div
      v-show="yearDataDetail[currentYearIndex]['专题活动']"
      class="zhuantihuodong data-circle"
      :style="{
        transform: `translate(${bubbleTranslation[2].x}rem, ${bubbleTranslation[2].y}rem)`
      }"
    >
      <h3>
        专题活动
      </h3>
      <div class="data-wrapper">
        <span class="number-big">{{ bubbleDataForShow['专题活动'][0] }}</span>
        <span class="number-small">{{ bubbleDataForShow['专题活动'][1] }}</span>
      </div>
      <img
        draggable="false"
        src="@/assets/image/专题活动.png"
        alt=""
      >
    </div>
    <div
      v-show="yearDataDetail[currentYearIndex]['活动数']"
      class="huodongshu data-circle"
      :style="{
        transform: `translate(${bubbleTranslation[3].x}rem, ${bubbleTranslation[3].y}rem)`
      }"
    >
      <h3>活动数</h3>
      <div class="data-wrapper">
        <span class="number-big">{{ bubbleDataForShow['活动数'][0] }}</span>
        <span class="number-small">{{ bubbleDataForShow['活动数'][1] }}</span>
      </div>
      <img
        draggable="false"
        src="@/assets/image/活动数.png"
        alt=""
      >
    </div>
    <div
      v-show="yearDataDetail[currentYearIndex]['微信粉丝']"
      class="weixinfensi data-circle"
      :style="{
        transform: `translate(${bubbleTranslation[4].x}rem, ${bubbleTranslation[4].y}rem)`
      }"
    >
      <h3>微信粉丝</h3>
      <div class="data-wrapper">
        <span class="number-big">{{ bubbleDataForShow['微信粉丝'][0] }}</span>
        <span class="number-small">{{ bubbleDataForShow['微信粉丝'][1] }}</span>
      </div>
      <img
        draggable="false"
        src="@/assets/image/微信粉丝.png"
        alt=""
      >
    </div>
    <div
      v-show="yearDataDetail[currentYearIndex]['外展数']"
      class="waizhanshu data-circle"
      :style="{
        transform: `translate(${bubbleTranslation[5].x}rem, ${bubbleTranslation[5].y}rem)`
      }"
    >
      <h3>外展数</h3>
      <div class="data-wrapper">
        <span class="number-big">{{ bubbleDataForShow['外展数'][0] }}</span>
        <span class="number-small">{{ bubbleDataForShow['外展数'][1] }}</span>
      </div>
      <img
        draggable="false"
        src="@/assets/image/外展数.png"
        alt=""
      >
    </div>
    <figure
      class="bottom-image"
    >
      <figcaption>博物馆能效趋势图</figcaption>
      <div class="echart-wrapper">
        <div
          v-show="yearDataDetail[currentYearIndex]['微信粉丝']"
          id="echart-fensi"
          class="echart"
        />
        <div
          v-show="yearDataDetail[currentYearIndex]['外展数']"
          id="echart-waizhan"
          class="echart"
        />
        <div
          v-show="yearDataDetail[currentYearIndex]['观众数']"
          id="echart-guanzhong"
          class="echart"
        />
        <div
          v-show="yearDataDetail[currentYearIndex]['临展数']"
          id="echart-linzhan"
          class="echart"
        />
        <div
          v-show="yearDataDetail[currentYearIndex]['活动数']"
          id="echart-huodong"
          class="echart"
        />
        <div
          v-show="yearDataDetail[currentYearIndex]['专题活动']"
          id="echart-zhuanti"
          class="echart"
        />
      </div>
    </figure>
    <SlideTip
      style="bottom: 17rem;"
    />
    <div
      ref="hammer-target"
      style="z-index: 1;"
      class="slide-to-nav-mask"
    />
  </div>
</template>

<script>
import TWEEN from '@tweenjs/tween.js'

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent
} from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
])

export default {
  name: 'Chart',
  props: {
  },
  data() {
    return {
      currentYearIndex: 7,
      addYearIntervalId: null,

      pickerYears: ['2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014'],
      yearDataDetail: [
        {
          year: '2022',
          '观众数': 1610747,
          '临展数': 13,
          '活动数': 591,
          '外展数': 5,
          '专题活动': null,
          '微信粉丝': 1575900
        },
        {
          year: '2021',
          '观众数': 2033657,
          '临展数': 15,
          '活动数': 441,
          '外展数': 20,
          '专题活动': null,
          '微信粉丝': 1304897
        },
        {
          year: '2020',
          '观众数': 1515321,
          '临展数': 17,
          '活动数': 438,
          '外展数': 15,
          '专题活动': null,
          '微信粉丝': 1140400
        },
        {
          year: '2019',
          '观众数': 4168900,
          '临展数': 21,
          '活动数': null,
          '外展数': 21,
          '专题活动': 1271,
          '微信粉丝': 856000
        },
        {
          year: '2018',
          '观众数': 3667650,
          '临展数': 18,
          '活动数': null,
          '外展数': 23,
          '专题活动': 621,
          '微信粉丝': null
        },
        {
          year: '2017',
          '观众数': 3295889,
          '临展数': 25,
          '活动数': null,
          '外展数': 29,
          '专题活动': 538,
          '微信粉丝': 1232994
        },
        {
          year: '2016',
          '观众数': 2881600,
          '临展数': 24,
          '活动数': 441,
          '外展数': 17,
          '专题活动': 496,
          '微信粉丝': 162350
        },
        {
          year: '2015',
          '观众数': 2580000,
          '临展数': 30,
          '活动数': 441,
          '外展数': null,
          '专题活动': null,
          '微信粉丝': 67546
        },
        {
          year: '2014',
          '观众数': 2260000,
          '临展数': 20,
          '活动数': 277,
          '外展数': 16,
          '专题活动': 3,
          '微信粉丝': 10000
        },
      ],
      bubbleTranslation: [
        {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
        },
        {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
        },
        {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
        },
        {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
        },
        {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
        },
        {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
        },
      ],
      lastPushBubbleTime: null,
      bubbleDataTweened: {
        '观众数': 0,
        '临展数': 0,
        '活动数': 0,
        '外展数': 0,
        '专题活动': 0,
        '微信粉丝': 0,
      },

      chartHuodong: null,
      chartZhuanti: null,
      chartWaizhan: null,
      chartGuanzhong: null,
      chartLinzhan: null,
      chartFensi: null,
      requestAnimationId: null,
    }
  },
  computed: {
    pickerItemHeight() {
      return 0.12919 * window.innerWidth
    },
    bubbleDataForShow() {
      const ret = {}
      for (const key in this.bubbleDataTweened) {
        ret[key] = []
        if (Object.hasOwnProperty.call(this.bubbleDataTweened, key)) {
          let temp = Math.round(this.bubbleDataTweened[key])
          if (temp >= 10000) {
            temp = temp.toString()
            ret[key][0] = temp.slice(0, -4) + '万'
            ret[key][1] = temp.slice(-4, temp.length) !== '0000' ? temp.toString().slice(-4, temp.length) : ''
          } else {
            ret[key][0] = temp
          }
        }
      }
      return ret
    },
    // ios里echart的x轴数据名必须这么设置……
    echartFontSize() {
      return window.innerHeight * 0.025276 * 0.7 + 'px'
    }
  },
  mounted() {
    this.chartHuodong = echarts.init(document.getElementById('echart-huodong'))
    this.chartZhuanti = echarts.init(document.getElementById('echart-zhuanti'))
    this.chartWaizhan = echarts.init(document.getElementById('echart-waizhan'))
    this.chartGuanzhong = echarts.init(document.getElementById('echart-guanzhong'))
    this.chartLinzhan = echarts.init(document.getElementById('echart-linzhan'))
    this.chartFensi = echarts.init(document.getElementById('echart-fensi'))
    this.animate()
    this.onPickerChange(null, null, this.currentYearIndex)
    // 基于准备好的dom，初始化echarts实例

    this.addYearIntervalId = setInterval(() => {
      const picker = this.$refs['year-picker']
      if (this.currentYearIndex !== 0) {
        this.currentYearIndex--
        picker.setColumnIndex(0, this.currentYearIndex)
        this.onPickerChange(null, null, this.currentYearIndex)
      } else {
        clearInterval(this.addYearIntervalId)
      }
    }, 3000)

    utils.registerSlideToRoute('hammer-target', 'End', this)
  },
  destroyed() {
    this.chartHuodong.dispose()
    this.chartZhuanti.dispose()
    this.chartWaizhan.dispose()
    this.chartGuanzhong.dispose()
    this.chartLinzhan.dispose()
    this.chartFensi.dispose()
    cancelAnimationFrame(this.requestAnimationId)
    clearInterval(this.addYearIntervalId)
  },
  methods: {
    onPickerChange(picker, value, index) {
      this.currentYearIndex = index
      const tween = new TWEEN.Tween(this.bubbleDataTweened)
      const currentYearData = this.yearDataDetail[this.currentYearIndex]
      tween.to({
        '观众数': currentYearData['观众数'],
        '临展数': currentYearData['临展数'],
        '活动数': currentYearData['活动数'],
        '外展数': currentYearData['外展数'],
        '专题活动': currentYearData['专题活动'],
        '微信粉丝': currentYearData['微信粉丝'],
      }, 1500)
      tween.easing(TWEEN.Easing.Quartic.Out)
      tween.start()

      // 绘制图表
      this.chartHuodong.setOption({
        xAxis: {
          data: ['活动数'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#4651BF',
            }
          },
          axisLabel: {
            fontSize: this.echartFontSize,
          }
        },
        yAxis: {
          max: '500',
          show: false,
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            barCategoryGap: '40%',
            data: [
              {
                value: currentYearData['活动数'],
                itemStyle: {
                  color: '#2fb779',
                }
              }
            ]
          }
        ]
      })
      this.chartZhuanti.setOption({
        xAxis: {
          data: ['专题数'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#4651BF',
            }
          },
          axisLabel: {
            fontSize: this.echartFontSize,
          }
        },
        yAxis: {
          max: '1500',
          show: false,
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            barCategoryGap: '40%',
            data: [
              {
                value: currentYearData['专题活动'],
                itemStyle: {
                  color: '#49a5d8',
                }
              }
            ]
          }
        ]
      })
      this.chartWaizhan.setOption({
        xAxis: {
          data: ['外展数'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#4651BF',
            }
          },
          axisLabel: {
            fontSize: this.echartFontSize,
          }
        },
        yAxis: {
          max: '50',
          show: false,
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            barCategoryGap: '40%',
            data: [
              {
                value: currentYearData['外展数'],
                itemStyle: {
                  color: '#18489d',
                }
              }
            ]
          }
        ]
      })
      this.chartGuanzhong.setOption({
        xAxis: {
          data: ['观众数'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#4651BF',
            }
          },
          axisLabel: {
            fontSize: this.echartFontSize,
          }
        },
        yAxis: {
          max: '4500000',
          show: false,
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            barCategoryGap: '40%',
            data: [
              {
                value: currentYearData['观众数'],
                itemStyle: {
                  color: '#f15835',
                }
              }
            ]
          }
        ]
      })
      this.chartLinzhan.setOption({
        xAxis: {
          data: ['临展数'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#4651BF',
            }
          },
          axisLabel: {
            fontSize: this.echartFontSize,
          }
        },
        yAxis: {
          max: '50',
          show: false,
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            barCategoryGap: '40%',
            data: [
              {
                value: currentYearData['临展数'],
                itemStyle: {
                  color: '#f5bec4',
                }
              }
            ]
          }
        ]
      })
      this.chartFensi.setOption({
        xAxis: {
          data: ['粉丝数'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#4651BF',
            }
          },
          axisLabel: {
            fontSize: this.echartFontSize,
          }
        },
        yAxis: {
          max: '1500000',
          show: false,
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            barCategoryGap: '40%',
            data: [
              {
                value: currentYearData['微信粉丝'],
                itemStyle: {
                  color: '#eebc29',
                }
              }
            ]
          }
        ]
      })
    },
    animate(callTime) {
      TWEEN.update()
      for (let index = 0; index < this.bubbleTranslation.length; index++) {
        const item = this.bubbleTranslation[index]
        if (callTime - this.lastPushBubbleTime > 1000) {
          item.vx += (Math.random() - 0.5) * 0.01
          if (item.vx > 0.02) {
            item.vx = 0.02
          }
          if (item.vx < -0.02) {
            item.vx = -0.02
          }
        }
        item.x += item.vx
        if (Math.abs(item.x) > 1) {
          item.vx *= -1
        }

        if (callTime - this.lastPushBubbleTime > 1000) {
          item.vy += (Math.random() - 0.5) * 0.01
          if (item.vy > 0.02) {
            item.vy = 0.02
          }
          if (item.vy < -0.02) {
            item.vy = -0.02
          }
        }
        item.y += item.vy
        if (Math.abs(item.y) > 1) {
          item.vy *= -1
        }
      }

      if (callTime - this.lastPushBubbleTime > 1000) {
        this.lastPushBubbleTime = callTime
      }
      this.requestAnimationId = requestAnimationFrame(this.animate)
    }
  }
}
</script>

<style lang="less">
.chart {
  .van-picker__mask {
    display: none;
  }
  .van-picker-column__item {
    color: #fff;
    font-size: 1.4rem;
    font-weight: bold;
  }
}
</style>

<style lang="less" scoped>
.chart {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .back-btn {
    position: absolute;
    z-index: 2;
  }
  .picker {
    width: 7.08rem;
    height: 7.08rem;
    border-radius: 50%;
    background: #33468B;
    position: absolute;
    top: 6.92rem;
    left: calc(50% - 4.25rem);
    overflow: hidden;
    z-index: 2;
  }
  .data-circle {
    position: absolute;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.84rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #4651BF;
    h3 {
      margin-bottom: 0.56rem;
    }
    > .data-wrapper {
      > .number-big {

        vertical-align: bottom;
      }
      > .number-small {
        font-size: 0.57rem;
        vertical-align: bottom;
      }
    }
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
  }
  .guanzhongshu {
    top: 2.11rem;
    left: calc(50% - 7.8rem);
    width: 4.91rem;
    height: 4.91rem;
  }
  .linzhanshu {
    top: 1.41rem;
    right: calc(50% - 3.76rem);
    width: 4.17rem;
    height: 4.17rem;
  }
  .zhuantihuodong {
    top: 5.42rem;
    right: calc(50% - 7.45rem);
    width: 4rem;
    height: 4rem;
  }
  .huodongshu {
    top: 10.91rem;
    right: calc(50% - 8.11rem);
    width: 4.03rem;
    height: 4.03rem;
  }
  .weixinfensi {
    top: 13.11rem;
    left: calc(50% - 8.28rem);
    width: 4.77rem;
    height: 4.77rem;
  }
  .waizhanshu {
    top: 16.16rem;
    right: calc(50% - 2.97rem);
    width: 3.59rem;
    height: 3.59rem;
  }
  .bottom-image {
    position: absolute;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%) scale(1.2);
    width: 90%;
    text-align: center;
    figcaption {
      font-size: 0.94rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #4651BF;
    }
    .echart-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      .echart {
        height: 12.36rem;
        width: 3rem;
        margin-left: -6px;
        margin-right: -6px;
      }
    }
  }
  .slide-to-nav-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // background: red;
    z-index: 1;
  }
  /deep/.van-picker__columns {
    cursor: pointer;
  }
}
</style>
